import { cronHttp } from "api/cronHttp";
import { http } from "api/http";
import OrgConfigDetails from "views/settings/organization/OrganizationProfile/OrgConfigDetails";

const getOrganization = () => {
  return http.get(`/organization`);
};

const updateOrganizationStorage = (data: any) => {
  return http.patch(`/organization/storage-status`, data)
}

const getGetStarted = () => {
  return http.get(`/get-started`);
};

const updateGetStarted = (data: any) => {
  return http.patch(`/get-started`, data);
};

const getOrganizationLicenses = ({ queryKey }) => {
  return http.get(`/organization-lincenses`, {
    params: {
      ...queryKey[1],
    },
  });
};

const getBankAccounts = ({ queryKey }) => {
  return http.get(`/bank-accounts`, {
    params: {
      ...queryKey[1],
    },
  });
};

const createBankAccount = (data: any) => {
  return http.post(`/bank-accounts`, data);
};

const updateBankAccount = ({ id, data }: any) => {
  return http.put(`/bank-accounts/${id}`, data);
};

const deleteBankAccount = ({ id }: any) => {
  return http.delete(`/bank-accounts/${id}`);
};

const defaultBankAccount = ({ id, data }: any) => {
  return http.put(`/bank-accounts/default/${id}`, data)
}

const createOrganizationLicense = ({ data }: any) => {
  return http.post(`/organization-lincenses`, data);
};

const updateOrganizationLicense = ({ id, data }: any) => {
  return http.patch(`/organization-lincenses/${id}`, data);
};

const updateOrganization = ({ data }: any) => {
  return http.patch(`/organization`, data);
};

const deleteOrganizationLicense = ({ id }: any) => {
  return http.delete(`/organization-lincenses/${id}`);
};

const getTaskAnalytics = ({ queryKey }) => {
  return http.get(`/stats/task-analytics`, { params: { ...queryKey[1] } });
};

const getDashboardEmployeeTimeSheet = (data: any) => {
  return http.post("/stats/dashboard-employee-timesheet", data);
};

const getDashboardEmployeeTimeSheetexport = (data: any) => {
  return cronHttp.post("/stats/dashboard-employee-timesheet/export", data);
};

const getLatestCollectDataSummary = async (data: any) => {
  const res = await http.post(`/collect-data/dashboard/summary-latest`, data);
  return res.data;
};
const getSubTaskStatusAnalytics = ({ queryKey }) => {
  return http.get(`/stats/sub-task-analytics`, { params: { ...queryKey[1] } });
};

const getTaskBoardAnalytics = ({ queryKey }) => {
  return http.get(`/tasks/task-analytics`, { params: { ...queryKey[1] } });
};

const getTaskFinancialYears = () => {
  return http.get('/tasks/financial-years');
};

const getTasksDueThisWeek = ({ queryKey }) => {
  const { dashboardType, range, clientId, dateType } = queryKey[1];

  return http.get(`/stats/tasks-due-this-week`, {
    params: {
      dashboardType,
      range,
      clientId,
      dateType,
    },
  });
};



const getTasksByCategory = ({ queryKey }) => {
  return http.get(`/stats/tasks-by-category`, { params: { ...queryKey[1] } });
};



const getTasksByCategoryExport = (data) => {
  return cronHttp.post(`/stats/tasks-by-category-export`, data);
};

const getTasksByClientCategory = ({ queryKey }) => {
  return http.get(`/stats/tasks-by-client-category`, { params: { ...queryKey[1] } });
};

const getTasksByClientCategoryExport = (data) => {
  return cronHttp.post(`/stats/tasks-by-client-category-export`, data);
};


const getTasksByService = ({ queryKey }) => {
  return http.get(`/stats/tasks-by-service`, { params: { ...queryKey[1] } });
};

const exportTasksByService = (data) => {
  return cronHttp.post(`/stats/tasks-by-service-export`, data);
};

const getOverdueTasks = ({ queryKey }) => {
  return http.get(`/stats/over-due-tasks`, { params: { ...queryKey[1] } });
};

const exportOverDueTask = (data) => {
  return cronHttp.post(`/stats/over-due-tasks-export`, data);
};

const getClientAnalytics = () => {
  return http.get(`/stats/client-analytics`);
};

const getClientBillingAnalytics = ({ queryKey }) => {
  return http.get(`/stats/client-billing-analytics`, { params: { ...queryKey[1] } });
}

const getDueDscRegisters = ({ queryKey }) => {
  return http.get(`/stats/due-dsc-registers`, {
    params: { ...queryKey[1] }
  });
};

const getClientsByCategory = ({ queryKey }) => {
  return http.get(`/stats/clients-by-category`, { params: { ...queryKey[1] } });
};
const getClientsByCategoryexport = (data) => {
  return cronHttp.post(`/stats/clients-by-category-export`, data);
};


const getTotalLogHours = ({ queryKey }) => {
  return http.get(`/stats/total-log-hours`, { params: { ...queryKey[1] } });
};

const getWeeklyLogHours = ({ queryKey }) => {
  return http.get(`/stats/weekly-log-hours`, { params: { ...queryKey[1] } });
};

const getClientTasksByStatus = ({ queryKey }) => {
  return http.get(`/stats/client-tasks-by-status`, { params: { ...queryKey[1] } });
};

const getServiceTasksByStatus = ({ queryKey }) => {
  return http.get(`/stats/service-tasks-by-status`, { params: { ...queryKey[1] } });
};

const getServiceTasksByStatusView = ({ queryKey }) => {
  return http.get(`/stats/service-tasks-by-status-view`, { params: { ...queryKey[1] } });
};

const getServiceTasksDetails = ({ queryKey }) => {
  return http.get(`/stats/service-task-details`, { params: { ...queryKey[1] } });
};

const getTaskLeaderTasksByStatus = ({ queryKey }) => {
  return http.get(`/stats/taskLeader-tasks-by-status`, { params: { ...queryKey[1] } });
};
const getUserTaskLeaderTasksByStatus = ({ queryKey }) => {
  return http.get(`/stats/user-taskLeader-tasks-by-status`, { params: { ...queryKey[1] } });
};


const getEmployeeTasksByStatus = ({ queryKey }) => {
  return http.get(`/stats/employee-tasks-by-status`, { params: { ...queryKey[1] } });
};

const exportEmployeeTasksByStatus = (data) => {
  return cronHttp.post(`/stats/employee-tasks-by-status-report`, data);
};

const getDailyAttendance = ({ queryKey }) => {
  return http.get(`/stats/employee-attendance`, { params: { ...queryKey[1] } });
};

const getTodayDailyAttendance = async ({ queryKey }) => {
  const [, params] = queryKey;
  const response = await http.get(`/stats/today-employee-attendance`,{ params });
  return response.data; 
};


const exportDailyAttendance = (payload: any) => {
  return cronHttp.post(`/stats/employee-attendance/export`, payload, {
    responseType: "blob", 
  });
};

const getSmtp = () => {
  return http.get(`/organization/smtp`);
};

const updateSmtp = ({ data }) => {
  return http.patch(`/organization/smtp`, data);
};

const updateSmtpMail = ({ data }) => {
  return http.patch(`/organization/smtp/mail`, data);
};

const updateSmtpPreferences = ({ data }) => {
  return http.patch(`/organization/smtp/preferences`, data);
};

const getUdinUsers = () => {
  return http.get('/organization/udin-users')
}

const getMcaV3Credentials = () => {
  return http.get("organization/mca-credentials");
};

const saveMcaV3Credentials = (data: any) => {
  return http.post("organization/mca-credentials", data);
};

const verifyMcaV3Credentials = (data: any) => {
  return http.post("organization/mca-credentials/verify", data);
};

const verifyMcaV3Otp = (data: any) => {
  return http.post("organization/mca-credentials/verify-otp", data);
};

const resendMcaV3Otp = (data: any) => {
  return http.post("organization/mca-credentials/resend-otp", data);
};

const deleteMcaV3User = () => {
  return http.delete(`/organization/mca-credentials`);
};

const getAuditConfig = ({ queryKey }) => {
  return http.get(`admin/getAuditConfig/${queryKey[1]}`);
};

const sendAuditAccessRequest = () => {
  return http.post("audit/sendAuditAccessRequest");
};

export {
  getTaskFinancialYears,
  exportOverDueTask,
  getTasksByClientCategoryExport,
  getTasksByCategoryExport,
  getClientsByCategoryexport,
  exportEmployeeTasksByStatus,
  exportTasksByService,
  getOrganization,
  updateOrganization,
  getOrganizationLicenses,
  createOrganizationLicense,
  updateOrganizationLicense,
  deleteOrganizationLicense,
  getBankAccounts,
  createBankAccount,
  updateBankAccount,
  deleteBankAccount,
  getTaskAnalytics,
  getGetStarted,
  updateGetStarted,
  getTasksDueThisWeek,
  getTasksByCategory,
  getTasksByClientCategory,
  getTasksByService,
  getOverdueTasks,
  getClientAnalytics,
  getDueDscRegisters,
  getClientsByCategory,
  getTotalLogHours,
  getWeeklyLogHours,
  getEmployeeTasksByStatus,
  OrgConfigDetails,
  getTaskBoardAnalytics,
  defaultBankAccount,
  getSmtp,
  updateSmtp,
  getDailyAttendance,
  getClientBillingAnalytics,
  getUdinUsers,
  updateSmtpMail,
  updateSmtpPreferences,
  updateOrganizationStorage,
  exportDailyAttendance,
  getMcaV3Credentials,
  saveMcaV3Credentials,
  verifyMcaV3Credentials,
  verifyMcaV3Otp,
  resendMcaV3Otp,
  deleteMcaV3User,
  getServiceTasksByStatus,
  getServiceTasksDetails,
  getClientTasksByStatus,
  getSubTaskStatusAnalytics,
  getTaskLeaderTasksByStatus,
  getUserTaskLeaderTasksByStatus,
  getDashboardEmployeeTimeSheet,
  getLatestCollectDataSummary,
  getTodayDailyAttendance,
  getServiceTasksByStatusView,
  getDashboardEmployeeTimeSheetexport,
  getAuditConfig,
  sendAuditAccessRequest
};
